import { render, staticRenderFns } from "./Identicon.vue?vue&type=template&id=476f296b"
import script from "./Identicon.vue?vue&type=script&lang=js"
export * from "./Identicon.vue?vue&type=script&lang=js"
import style0 from "./Identicon.vue?vue&type=style&index=0&id=476f296b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports